export const companyActions = {
  LOAD_COMPANY_LIST: 'LOAD_COMPANY_LIST',
  LOAD_COMPANY_LIST_SUCCESS: 'LOAD_COMPANY_LIST_SUCCESS',
  LOAD_COMPANY_LIST_FAIL: 'LOAD_COMPANY_LIST_FAIL',

  LOAD_MY_COMPANY_LIST: 'LOAD_MY_COMPANY_LIST',
  LOAD_MY_COMPANY_LIST_SUCCESS: 'LOAD_MY_COMPANY_LIST_SUCCESS',
  LOAD_MY_COMPANY_LIST_FAIL: 'LOAD_MY_COMPANY_LIST_FAIL',

  LOAD_COMPANY: 'LOAD_COMPANY',
  LOAD_COMPANY_SUCCESS: 'LOAD_COMPANY_SUCCESS',
  LOAD_COMPANY_FAIL: 'LOAD_COMPANY_FAIL',

  LOAD_COMPANY_ANALYTICS: 'LOAD_COMPANY_ANALYTICS',
  LOAD_COMPANY_ANALYTICS_SUCCESS: 'LOAD_COMPANY_ANALYTICS_SUCCESS',
  LOAD_COMPANY_ANALYTICS_FAIL: 'LOAD_COMPANY_ANALYTICS_FAIL',

  UPDATE_COMPANY: 'UPDATE_COMPANY',
  UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_FAIL: 'UPDATE_COMPANY_FAIL',

  EXPORT_COMPANY_ANALYTICS: 'EXPORT_COMPANY_ANALYTICS',
  EXPORT_COMPANY_ANALYTICS_SUCCESS: 'EXPORT_COMPANY_ANALYTICS_SUCCESS',
  EXPORT_COMPANY_ANALYTICS_FAIL: 'EXPORT_COMPANY_ANALYTICS_FAIL',

  EXPORT_COMPANIES: 'EXPORT_COMPANIES',
  EXPORT_COMPANIES_SUCCESS: 'EXPORT_COMPANIES_SUCCESS',
  EXPORT_COMPANIES_FAIL: 'EXPORT_COMPANIES_FAIL',

  loadCompanyList: () => ({
    type: companyActions.LOAD_COMPANY_LIST,
  }),
  loadCompanyListSuccess: data => ({
    type: companyActions.LOAD_COMPANY_LIST_SUCCESS,
    payload: { data },
  }),
  loadCompanyListFail: error => ({
    type: companyActions.LOAD_COMPANY_LIST_FAIL,
    payload: { error },
  }),

  loadMyCompanyList: () => ({
    type: companyActions.LOAD_MY_COMPANY_LIST,
  }),
  loadMyCompanyListSuccess: data => ({
    type: companyActions.LOAD_MY_COMPANY_LIST_SUCCESS,
    payload: { data },
  }),
  loadMyCompanyListFail: error => ({
    type: companyActions.LOAD_MY_COMPANY_LIST_FAIL,
    payload: { error },
  }),

  loadCompany: companyId => ({
    type: companyActions.LOAD_COMPANY,
    payload: { companyId },
  }),
  loadCompanySuccess: data => ({
    type: companyActions.LOAD_COMPANY_SUCCESS,
    payload: { data },
  }),
  loadCompanyFail: error => ({
    type: companyActions.LOAD_COMPANY_FAIL,
    payload: { error },
  }),

  loadCompanyAnalytics: companyId => ({
    type: companyActions.LOAD_COMPANY_ANALYTICS,
    payload: { companyId },
  }),
  loadCompanyAnalyticsSuccess: data => ({
    type: companyActions.LOAD_COMPANY_ANALYTICS_SUCCESS,
    payload: { data },
  }),
  loadCompanyAnalyticsFail: error => ({
    type: companyActions.LOAD_COMPANY_ANALYTICS_FAIL,
    payload: { error },
  }),

  updateCompany: (companyId, company) => ({
    type: companyActions.UPDATE_COMPANY,
    payload: { companyId, company },
  }),
  updateCompanySuccess: () => ({
    type: companyActions.UPDATE_COMPANY_SUCCESS,
  }),
  updateCompanyFail: error => ({
    type: companyActions.UPDATE_COMPANY_FAIL,
    payload: { error },
  }),

  exportCompanyAnalytics: (companyId, companyName, action) => ({
    type: companyActions.EXPORT_COMPANY_ANALYTICS,
    payload: { companyId, companyName, action },
  }),
  exportCompanyAnalyticsSuccess: () => ({
    type: companyActions.EXPORT_COMPANY_ANALYTICS_SUCCESS,
  }),
  exportCompanyAnalyticsFail: error => ({
    type: companyActions.EXPORT_COMPANY_ANALYTICS_FAIL,
    payload: { error },
  }),

  exportCompanies: () => ({
    type: companyActions.EXPORT_COMPANIES,
    payload: {},
  }),
  exportCompaniesSuccess: () => ({
    type: companyActions.EXPORT_COMPANIES_SUCCESS,
  }),
  exportCompaniesFail: error => ({
    type: companyActions.EXPORT_COMPANIES_FAIL,
    payload: { error },
  }),
};
